<template>
  <div
    id="sidebar-wrap"
    class="sidebar-area position-fixed bg_primary transition"
  >
    <div id="sidebar_menu_wrap" class="sidebar-menu-wrap">
      <ul class="sidebar-menu list-style">
        <li class="nav-item">
          <router-link to="/" class="nav-link">
            <img src="../../assets/img/icons/dashboard.svg" alt="Image" />
            <span class="nav-text d-block fs-14 fw-light"> Dashboard </span>
          </router-link>
        </li>
        <li class="nav-item">
          <a href="javascript:void(0)" class="nav-link">
            <img src="../../assets/img/icons/sale.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Ventas </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item">
              <router-link to="/pos">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                Nueva Venta (POS)
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/sales-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                Historial de Ventas
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <router-link to="/proveedores" class="nav-link">
            <img src="../../assets/img/icons/adjustments.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Proveedores </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/product-list" class="nav-link">
            <img src="../../assets/img/icons/products.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Productos </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/transfer-list" class="nav-link">
            <img src="../../assets/img/icons/transfer.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Transferencias </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/ajustes-inventario" class="nav-link">
            <img src="../../assets/img/icons/adjustments.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Ajustes de Inventario </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/inventario-fisico" class="nav-link">
            <img src="../../assets/img/icons/adjustments.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Inventario Físico </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/contabilidad" class="nav-link">
            <img src="../../assets/img/icons/reports.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Contabilidad </span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/series-documentos" class="nav-link">
            <img src="../../assets/img/icons/adjustments.svg" alt="" />
            <span class="nav-text d-block fs-14"> Series de Documentos </span>
          </router-link>
        </li>
        <li class="nav-item">
          <a href="javascript:void(0)" class="nav-link">
            <img src="../../assets/img/icons/purchase.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Compras </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item">
              <router-link to="/nueva-compra">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                Nueva Compra
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/purchase-list">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                Historial de Compras
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/importar-xml">
                <img src="../../assets/img/icons/create-item.svg" alt="Image" />
                Importar XML + PDF
                <span class="beta-badge">Beta</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/recepcion-mercaderia">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                Recepción de Mercadería
                <span class="beta-badge">Beta</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <a href="javascript:void(0)" class="nav-link">
            <img src="../../assets/img/icons/reports.svg" alt="Image" />
            <span class="nav-text d-block fs-14"> Documentación </span>
          </a>
          <ul class="sidebar-secondary-menu bg-white list-style">
            <li class="nav-item">
              <router-link to="/estado-proyecto">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                Estado del Proyecto
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/reglas-negocio">
                <img src="../../assets/img/icons/item-list.svg" alt="Image" />
                Reglas de Negocio
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default { name: "MainSidebar" };
</script>

<style lang="scss" scoped>
.sidebar-area {
  top: 100px;
  left: 0;
  height: 100%;
  z-index: 2;
  transition: var(--transition);
  .sidebar-menu-wrap {
    padding: 40px;
    z-index: 2;
    .sidebar-menu {
      position: relative;
      z-index: 2;
      & > .nav-item {
        margin-bottom: 25px;
        display: block;
        &:last-child {
          margin-bottom: 0;
        }
        & > .nav-link {
          position: relative;
          background-color: #2c3a52;
          text-align: center;
          display: inline-block;
          width: 128px;
          height: 100px;
          border-radius: 4px;
          padding: 19px 5px 18px;
          transition: var(--transition);
          z-index: 1;

          &:after {
            position: absolute;
            bottom: 0;
            left: 0;
            content: "";
            width: 100%;
            height: 0;
            border-radius: 4px;
            background: var(
              --Purple-Gradient,
              linear-gradient(132deg, #4f46e5 4.27%, #6366f1 100%)
            );
            visibility: hidden;
            opacity: 0;
            transition: var(--transition);
            z-index: -1;
          }
          img {
            display: block;
            margin: 0 auto;
          }
          .nav-text {
            color: #c6c7d3;
            margin-top: 5px;
          }
          &.active {
            &:after {
              visibility: visible;
              opacity: 1;
              height: 100%;
            }
          }
        }
        &.active,
        &:hover {
          & > .nav-link {
            &:after {
              visibility: visible;
              opacity: 1;
              height: 100%;
            }
          }
        }
        &:has(ul.sidebar-secondary-menu li a.active) {
          & > .nav-link {
            &:after {
              visibility: visible;
              opacity: 1;
              height: 100%;
            }
          }
        }
        .sidebar-secondary-menu {
          position: fixed;
          top: 100px;
          left: 208px;
          width: 280px;
          height: calc(100vh - 100px);
          visibility: hidden;
          opacity: 0;
          transition: var(--transition);
          z-index: 0;
          overflow-y: auto;
          box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.06);
          li {
            a {
              font-size: 14px;
              color: var(--primaryColor);
              transition: var(--transition);
              padding: 14px 25px;
              display: block;
              width: 100%;
              img {
                position: relative;
                margin-right: 8px;
                top: -1.5px;
              }
              &.active,
              &:hover {
                background-color: #f3f8ff;
              }
            }
          }
        }
        &:hover {
          .sidebar-secondary-menu {
            visibility: visible;
            opacity: 1;
          }
        }
      }
    }
  }
}
.beta-badge {
  display: inline-block;
  margin-left: 6px;
  padding: 1px 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  border-radius: 4px;
  vertical-align: middle;
  line-height: 1.4;
  text-transform: uppercase;
}
#sidebar_menu_wrap {
  position: relative;
  z-index: 1;
  height: calc(100vh - 100px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    height: 7px;
    width: 7px;
    background: var(--primaryColor);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5);
    -webkit-border-radius: 1ex;
    -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.75);
  }
  &::-webkit-scrollbar-corner {
    background: #000;
  }
}

@media only screen and (max-width: 575px) {
  .sidebar-area {
    top: 116px;
    .sidebar-menu-wrap {
      padding: 25px 15px;
      .sidebar-menu {
        & > .nav-item {
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          & > .nav-link {
            width: 55px;
            height: 55px;
            padding: 14px 5px 12px;
            img {
              max-width: 27px;
            }
            .nav-text {
              display: none !important;
            }
          }
          .sidebar-secondary-menu {
            top: 116px;
            left: 80px;
            width: 250px;
            height: 100vh;
            li {
              a {
                font-size: 14px;
                padding: 14px 20px;
              }
            }
          }
        }
      }
    }
  }
  #sidebar_menu_wrap {
    height: calc(100vh - 116px);
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .sidebar-area {
    top: 80px;
    .sidebar-menu-wrap {
      .sidebar-menu {
        & > .nav-item {
          .sidebar-secondary-menu {
            top: 79px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 1199px) {
}
</style>
